module.exports = __webpack_public_path__ + "static/media/orders.12811cf3.svg";